import { Form, FormProps, Input, ModalProps } from 'antd';
import { useTranslate } from '@tolgee/react';
import useAccountValidator from 'views/Assistant/hooks/useAccountValidator';
import { WideButton } from './styles';
import OpenModalOfContent from '../openModalOfContent';

export interface OnlyAccountFormProps extends FormProps {}

const OnlyAccountForm = (props: OnlyAccountFormProps) => {
  const accountValidator = useAccountValidator();
  const { t } = useTranslate();

  return (
    <Form {...props}>
      <Form.Item
        required
        rules={[
          {
            validator: (_, account) => {
              const error = accountValidator(account ?? '', true);
              return error ? Promise.reject(new Error(error)) : Promise.resolve();
            },
          },
        ]}
        name="account"
      >
        <Input />
      </Form.Item>
      <WideButton type="primary" htmlType="submit">
        {t('modals.确认修改')}
      </WideButton>
    </Form>
  );
};
export default OnlyAccountForm;

export const OpenOnlyAccountFormModal = ({
  onSubmit,
  ...otherProps
}: ModalProps & { onSubmit: (account: string) => any }) => {
  const { t } = useTranslate();
  const props = {
    title: t('modals.帐号信息'),
    subTitle: t('modals.设置登录帐号'),
    desc: t('modals.account.rules.tips'),
    content: (
      <OnlyAccountForm
        onFinish={(val: { account: string }) => {
          return onSubmit(val.account);
        }}
      />
    ),
    ...otherProps,
  };
  return <OpenModalOfContent {...props} />;
};
